import React from 'react';

import i18n from 'i18n-react';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';

import ActionCard from 'components/ActionCard';


const crumbRoutes = {
  '/main': 'Home',
  '/main/off': 'Not Logged In',
};

const NotLoggedInView = () => (
  <div className="contentContainer">
    <Breadcrumbs
      mappedRoutes={crumbRoutes}
      WrapperComponent={props => <ul className="breadcrumb__List">{props.children}</ul>}
      LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
      ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
    />
    <ActionCard
      superTitle={i18n.translate('notLoggedIn.super')}
      title={i18n.translate('notLoggedIn.title')}
      buttonText={i18n.translate('general.logIn')}
      buttonLink="/login"
      buttonIcon="fa-user"
    />
  </div>
);

export default NotLoggedInView;
